import { addToChainAfter, HandlerWithResult } from "@insite/client-framework/HandlerCreator";
import { getCategoryState } from "@insite/client-framework/Store/Data/Categories/CategoriesSelectors";
import { chain, DispatchSetProductFilters } from "@insite/client-framework/Store/Pages/ProductList/Handlers/AddProductFilters";
import { ProductFilters } from "@insite/client-framework/Store/Pages/ProductList/ProductListState";
import { PdpPaginationChange } from "@WhiteCap/Common/Utillities/CustomTracking";

type HandlerType = HandlerWithResult<ProductFilters, ProductFilters>;
export const AddProductFiltersSendDataLayer: HandlerType = props => {
    if (props?.parameter?.page && props?.result?.pageCategoryId) {
        const pageCategoryId = props.result.pageCategoryId;
        const state = props.getState();
        const category = getCategoryState(state, pageCategoryId)?.value;
        if (category && category?.shortDescription) {
            PdpPaginationChange({
                event: "pagination",
                'item_category': category?.shortDescription,
            })
        }
    }
};

addToChainAfter(chain, DispatchSetProductFilters, AddProductFiltersSendDataLayer);